// extracted by mini-css-extract-plugin
module.exports = {"root":"SCPrgQ4iAQ3fYpg1Jtsm","horizontal":"AZbfQbtpJcl_SJibEigL","vertical":"MeTEd8ArQv43BX_9pxZO"};